import { render, staticRenderFns } from "./GestioneModificheDB.vue?vue&type=template&id=7fbe89eb&scoped=true&"
import script from "./GestioneModificheDB.vue?vue&type=script&lang=js&"
export * from "./GestioneModificheDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe89eb",
  null
  
)

export default component.exports